import React from 'react'
import Pt from 'prop-types'
import Ipt from 'react-immutable-proptypes'
import { Panel } from 'react-bootstrap'

import Icon from 'internal-components/src/components/Icon'
import Offer from './Offer'
import {connect} from "react-redux";
import {makeSelectOffers} from "../../../deps/internal-components/src/redux/modules/product/selectors";

function OfferGrid({ currentOffer, offers, selectOffer }) {
  return (
    <section id="offer-grid">
      {!offers.size && (
        <Panel className="select-product">
          <Panel.Body>
            <Icon size="5x" name="hand-o-left" className="pull-left" />
            <p>
              There are no products that match your current filter settings.
            </p>
          </Panel.Body>
        </Panel>
      )}
      {offers.map(offer => (
        <Offer
          key={offer.id}
          offer={offer}
          onClick={() => selectOffer(offer.id)}
          selected={currentOffer && currentOffer.id === offer.id}
        />
      ))}
    </section>
  )
}

OfferGrid.propTypes = {
  currentOffer: Ipt.record,
  offers: Ipt.orderedSet.isRequired,
  selectOffer: Pt.func.isRequired,
}

export const makeMapStateToProps = () => {
  const selectOffers = makeSelectOffers()

  return (state, ownProps) => ({
    offers: selectOffers(state, ownProps),
  })
}

export default connect(makeMapStateToProps)(OfferGrid)



// WEBPACK FOOTER //
// ./src/components/OfferSelector/OfferGrid.jsx